
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.375 16.375h-9.75v-9.75h9.75m0-1.625h-9.75A1.625 1.625 0 005 6.625v9.75A1.625 1.625 0 006.625 18h9.75A1.625 1.625 0 0018 16.375v-9.75C18 5.723 17.269 5 16.375 5z"}}),_c('path',{attrs:{"d":"M10.049 9.501h1.06v1.607H9.5V9.928l-.085.085-1.451 1.452-.036.035.036.035 1.45 1.452.086.085V11.892h1.607v1.607H9.928l.085.085 1.452 1.451.035.036.035-.036 1.452-1.45.085-.086H11.892v-1.607h1.607V13.072l.085-.085 1.451-1.452.036-.035-.036-.035-1.45-1.452-.086-.085V11.108h-1.607V9.502H13.072l-.085-.085-1.452-1.451-.035-.036-.035.036-1.452 1.45-.085.086h.12z","stroke":"#444","stroke-width":".1"}}),_c('path',{attrs:{"d":"M5.74 20.438c-2.075-.982-3.56-2.963-3.788-5.313H1C1.317 18.975 4.59 22 8.581 22c.146 0 .28 0 .419-.019l-2.417-2.387-.844.843zM17.26 2.563c2.075.98 3.56 2.962 3.788 5.312H22C21.683 4.025 18.41 1 14.419 1c-.146 0-.28 0-.419.019l2.417 2.387.844-.844z"}})])
          )
        }
      }
    